import React from "react";
var __jsx = React.createElement;
import NextLink from "next/link";
import { useEffect, useRef } from "react";
import ELSCSSGrid from "components/common/elsevier/CSSGrid/CSSGrid";
import ELSCSSGridItem from "components/common/elsevier/CSSGrid/CSSGridItem";
import UpRightIcon from "components/common/elsevier/Icons/UpRightIcon";
import styles from "./GlobalFooter.module.scss";
import { ELSButton } from "../../../common/elsevier/Button/Button";

/* eslint jsx-a11y/anchor-is-valid: "off" */

export default function GlobalFooter() {
  // The useEffect method is called for A11y purposes so Cookie Settings span can be opened on Press Enter.
  var spanCookieSettingsRef = useRef(null);
  useEffect(function () {
    var span = spanCookieSettingsRef.current;

    /* //Possible solution to rename the cookie compliance button text that gets modified by the Onetrust script
    setTimeout(() => {
      const cookieText = document.getElementById("ot-sdk-btn");
      cookieText.textContent = "use of cookies";
    }, 1500);
     */

    function handleClick() {
      span.click();
    }
    function handleKeyDown(event) {
      if (event.keyCode === 13) {
        span.click();
      }
    }
    span.addEventListener("keydown", handleKeyDown);
    span.addEventListener("click", handleClick);
    return function () {
      span.removeEventListener("keydown", handleKeyDown);
      span.removeEventListener("click", handleClick);
    };
  }, []);
  return /*#__PURE__*/React.createElement(ELSCSSGrid, {
    id: styles.ev__copyright
  }, /*#__PURE__*/React.createElement(ELSCSSGridItem, {
    className: "grid-start"
  }, /*#__PURE__*/React.createElement(NextLink, {
    legacyBehavior: true,
    href: "https://www.elsevier.com/",
    forwardref: true
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": "go to www.elsevier.com - opens new window",
    className: "es-logo",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-elsevier-link"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Elsevier Logo",
    src: "".concat(process.env.customBasePath, "/static/images/logos/elsevier_tree_logo.svg"),
    height: "80",
    width: "72"
  })))), /*#__PURE__*/React.createElement(ELSCSSGridItem, {
    id: "ev__copyright-content"
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.footer__links
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ELSButton, {
    className: "es-link__black--14-font es-link__icon--right",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-ev-link",
    href: "http://www.elsevier.com/solutions/engineering-village",
    endIcon: /*#__PURE__*/React.createElement(UpRightIcon, null)
  }, /*#__PURE__*/React.createElement("span", {
    className: "es-link__text"
  }, "About Engineering Village"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ELSButton, {
    className: "es-link__black--14-font es-link__icon--right",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-access-link",
    href: "https://service.elsevier.com/app/home/supporthub/elsevieraccess/",
    endIcon: /*#__PURE__*/React.createElement(UpRightIcon, null)
  }, /*#__PURE__*/React.createElement("span", {
    className: "es-link__text"
  }, "Access"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ELSButton, {
    className: "es-link__black--14-font es-link__icon--right",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-accessibility-link",
    href: "http://www.elsevier.com/solutions/engineering-village/features/accessibility",
    endIcon: /*#__PURE__*/React.createElement(UpRightIcon, null)
  }, /*#__PURE__*/React.createElement("span", {
    className: "es-link__text"
  }, "Accessibility Statement"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ELSButton, {
    className: "es-link__black--14-font es-link__icon--right",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-contact-link",
    href: "https://service.elsevier.com/app/overview/engineering-village/",
    endIcon: /*#__PURE__*/React.createElement(UpRightIcon, null)
  }, /*#__PURE__*/React.createElement("span", {
    className: "es-link__text"
  }, "Contact and support"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ELSButton, {
    className: "es-link__black--14-font es-link__icon--right",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-terms-link",
    href: "https://www.elsevier.com/legal/elsevier-website-terms-and-conditions",
    endIcon: /*#__PURE__*/React.createElement(UpRightIcon, null)
  }, /*#__PURE__*/React.createElement("span", {
    className: "es-link__text"
  }, "Terms and conditions"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ELSButton, {
    className: "es-link__black--14-font es-link__icon--right",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-privacy-link",
    href: "https://www.elsevier.com/legal/privacy-policy",
    endIcon: /*#__PURE__*/React.createElement(UpRightIcon, null)
  }, /*#__PURE__*/React.createElement("span", {
    className: "es-link__text"
  }, "Privacy policy"), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window")))), /*#__PURE__*/React.createElement("p", {
    className: styles["ev__copyright-statement"]
  }, "Copyright \xA9 ", new Date().getFullYear(), " Elsevier B.V., its licensors, and contributors. All rights are reserved, including those for text and data mining, AI training, and similar technologies.", /*#__PURE__*/React.createElement("br", null), " We use cookies to help provide and enhance our service and tailor content. By continuing, you agree to the", " ", /*#__PURE__*/React.createElement("button", {
    type: "button",
    ref: spanCookieSettingsRef,
    id: "ot-sdk-btn",
    tabIndex: "0",
    className: "ot-sdk-show-settings es-link es-link__black--14-font ".concat(styles["ot-sdk-show-settings"])
  }, "Cookie settings"), ".")), /*#__PURE__*/React.createElement(ELSCSSGridItem, {
    className: "grid-end grid-top"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": "go to www.relx.com - opens new window",
    className: "logo",
    href: "https://www.relx.com/",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    "data-cy": "footer-relx-link"
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(process.env.customBasePath, "/static/images/logos/relx_logo.svg"),
    alt: "RELX logo",
    height: "20",
    width: "86"
  }))));
}